import { Typography } from 'antd'

import { momentDateHandler } from '../../date/moment-date-handler'
import { formatCurrency, toFixed } from '../../formatters'
import { getEnvironmentHost } from '../../util/environment'
import { emptyCharacter } from '../EmptyChar'

const { newDate, formatDate } = momentDateHandler

export const renderDate = (date: Date) => formatDate({ date: newDate(date) })

export const renderPrincipal = (principal: number) => formatCurrency({ value: principal })

export const renderCoupon = (coupon: number) => (coupon ? toFixed({ value: coupon, precision: 4 }) : emptyCharacter)

export const renderBasisPointFee = (basisPointFee: number) => (basisPointFee > 0 ? basisPointFee : emptyCharacter)

export const renderEmail = (email: string) => <a href={`mailto:${email}`}>{email}</a>

export const renderTenantLink = (domain: string) => {
  const url = getEnvironmentHost({ domain })

  return (
    <Typography.Link href={url} target="_blank">
      {url}
    </Typography.Link>
  )
}

export const renderTenantPathLink = (domain: string, path?: string) => {
  const url = getEnvironmentHost({ domain })

  return (
    <Typography.Link href={`${url}${path}`} target="_blank">
      {`${url}${path}`}
    </Typography.Link>
  )
}
